import React from 'react'
import UserTable from '../../Components/Users/UserTable'

function Users() {
  return (
    <div>
      <UserTable/>
    </div>
  )
}

export default Users